export const SET_STEP = 'setPhone';
export const VERIFY_STEP = 'verifyPhone';
